
import {useMemo} from "react";
import React from "react";

export default function ChatCitation({file, pageNumber, quote}: {
    file: any,
    pageNumber: any,
    quote: any,
    page: any,
}) {
    const viewerUrl = useMemo(() => {
        if (!file || !file.endsWith(".pdf")) return null;

        const search = quote
            ? encodeURIComponent(quote.trim().replace(/^[\s.,'"’]+|[\s.,'"’]+$/g, ""))
            : "";

        return `/lib/pdf_viewer/viewer.html?file=/Data/${encodeURIComponent(
            file
        )}#page=${pageNumber || 1}&search=${search}&phrase=true`;
    }, [file, pageNumber, quote]);

    if (!viewerUrl) return null;

    return (
        <a
            href={viewerUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-2 p-2 border border-gray-200 rounded-md hover:bg-gray-50 citation"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 flex-shrink-0 text-gray-500"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                />
            </svg>

            <div className="flex flex-col">
                <div className="font-medium">{file}</div>
                <div className="text-gray-500">{quote}</div>
            </div>
        </a>
    );
}